import type { ConceptEmitter, Graph } from "@lr-notitia/notitia-designer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptEmitters = (graph: Ref<Graph>) =>
	computed<ConceptEmitter[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "emitter" && node.layer === "concept"
			) as ConceptEmitter[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
				)
		);
	});
export function conceptEmitter(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): ConceptEmitter | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "emitter" && hit.layer === "concept" ? (hit as ConceptEmitter) : undefined;
}
